module.exports = __webpack_public_path__ + "static/nosso-atendimento-89335b077976fddf0337bc15eb44e953.svg";